import api from '../middleware/Api';
const Event = {
    get: (eventId) => api.get(`/new/event/${eventId}`),
    getByUser: (userId) => api.get(`/account-contact/${userId}/events`),
    getAccountLogo: (accountId) => api.get(`/editor/images/account-logo/get/${accountId}`),
}

export default Event